/**
 * Unified toast notification composable for all OnePlaceHQ modules.
 *
 * Wraps vue-toastification with a consistent API.
 * See docs/TOAST_SYSTEM.md for full documentation.
 *
 * Usage:
 *   import { useToast } from '@shared/composables/useToast.js'
 *   const toast = useToast()
 *   toast.success('Invoice saved')
 *   toast.error('Failed to delete')
 */
import { useToast as _useToast } from 'vue-toastification'

export function useToast() {
  const toast = _useToast()

  return {
    /** Show success toast (auto-dismiss 4s with progress bar) */
    success: (msg, opts) => toast.success(msg, opts),

    /** Show error toast (persistent — must be manually closed) */
    error: (msg, opts) => toast.error(msg, opts),

    /** Show warning toast (auto-dismiss 7s with progress bar) */
    warning: (msg, opts) => toast.warning(msg, opts),

    /** Show info toast (auto-dismiss 5s with progress bar) */
    info: (msg, opts) => toast.info(msg, opts),

    /** Dismiss a specific toast by ID */
    dismiss: (id) => toast.dismiss(id),

    /** Clear all toasts */
    clear: () => toast.clear(),
  }
}
